import {baseDevConfig, baseLocalConfig, baseProdConfig, baseQaConfig, baseStagingConfig} from './base';
import {
  cbsnewsDevConfig,
  cbsnewsLocalConfig,
  cbsnewsProdConfig,
  cbsnewsQaConfig,
  cbsnewsDecoStagingConfig,
  cbsnewsStagingConfig,
} from './cbsnews';
import {
  cbssportsDevConfig,
  cbssportsLocalConfig,
  cbssportsProdConfig,
  cbssportsQaConfig,
  cbssportsStagingConfig,
} from './cbssports';
import {cnetAlphaConfig, cnetDevConfig, cnetLocalConfig, cnetProdConfig, cnetQaConfig, cnetStagingConfig} from './cnet';
import {sportslineProductionConfig} from './sportsline/prod.config';
import {sportslineStagingConfig} from './sportsline/staging.config';

export const configMap = {
  sites: ['cbsi', 'cnet', 'cbsnews', 'cbssports', 'sportsline'],
  configs: {
    cbsi: {
      'localhost': baseLocalConfig,
      'local-mobilecms': baseLocalConfig,
      'dev-mobilecms': baseDevConfig,
      'qa-mobilecms': baseQaConfig,
      'staging-mobilecms': baseStagingConfig,
      'mobilecms': baseProdConfig,
      'default': baseStagingConfig,
    },
    cnet: {
      'gcp-local-mobilecms': cnetLocalConfig,
      'gcp-dev-mobilecms': cnetDevConfig,
      'gcp-qa-mobilecms': cnetQaConfig,
      'staging-mobilecms': cnetStagingConfig,
      'gcp-alpha-mobilecms': cnetAlphaConfig,
      'mobilecms': cnetProdConfig,
      'default': cnetAlphaConfig,
    },
    cbsnews: {
      'local-mobilecms': cbsnewsLocalConfig,
      'dev-mobilecms': cbsnewsDevConfig,
      'qa-mobilecms': cbsnewsQaConfig,
      'staging-mobilecms': cbsnewsDecoStagingConfig,
      'stage-mobilecms': cbsnewsStagingConfig,
      'mobilecms': cbsnewsProdConfig,
      'default': cbsnewsStagingConfig,
    },
    cbssports: {
      'local-mobilecms': cbssportsLocalConfig,
      'dev-mobilecms': cbssportsDevConfig,
      'qa-mobilecms': cbssportsQaConfig,
      'staging-mobilecms': cbssportsStagingConfig,
      'mobilecms': cbssportsProdConfig,
      'default': cbssportsStagingConfig,
    },
    sportsline: {
      'staging-mobilecms': sportslineStagingConfig,
      'mobilecms': sportslineProductionConfig,
      'default': sportslineStagingConfig,
    },
    default: baseStagingConfig,
  },
};



// WEBPACK FOOTER //
// ./src/app/environment-variables/config.map.ts